import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useModal from "@/@core/components/base-modal/hooks/useModal";

import flashdealCampaignModel from "@/models/flashdeal/flashdeal-campaign";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import usePagination from "@/views/components/pagination/usePagination";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useDate from "@/utils/hooks/useDate";

export default function usePrivilegeCampaignList() {
  const { openModal, closeModal } = useModal();
  const {
    fetchFlashDealCampaignList,
    fetchFlashDealCampaignChangeStatus,
    fetchFlashDealCampaignRemove,
  } = flashdealCampaignModel();
  const { openDefaultErrorModal, openWarningModal , openSuccessModal } = useValidationModal();

  const { pagination, onPageChange, onFilterEntity } = usePagination();
  const { resolveDateWithSeperator, resolveTime } = useDate();

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const loading = reactive({
    tableData: false,
  });
  const fields = [
    { key: "seq", label: "No" },
    { key: "campaign_image_url", label: "Image" },
    { key: "name_th", label: "Campaign Name" },
    { key: "section", label: "Section" },
    { key: "total_privilege", label: "Privileges" },
    { key: "valid_from", label: "Valid From" },
    { key: "valid_through", label: "Valid Through" },
    { key: "status", label: "Open/Close" },
    { key: "actions", label: "" },
  ];
  
  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };
  const statusOption = ref([
    { label: "Open", value: 1 },
    { label: "Close", value: 2 },
  ]);

  const status = ref(0);

  const privilegeCampaignList = reactive({
    payload: [],
  });

  const fetchPrivilegeCampaignList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true;
    }
    fetchFlashDealCampaignList.payload.Page = pagination.currentPage;
    fetchFlashDealCampaignList.payload.Limit = pagination.perPage;
    fetchFlashDealCampaignList.payload.Filters = filters;
    store
      .dispatch("api/apiRequest", fetchFlashDealCampaignList)
      .then((response) => {
        privilegeCampaignList.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const changeCampaignStatus = (campaignId, status) => {
    loading.tableData = true;
    fetchFlashDealCampaignChangeStatus.payload.CampaignId = campaignId;
    fetchFlashDealCampaignChangeStatus.payload.Status = status ? 1 : 2;
    store
      .dispatch("api/apiRequest", fetchFlashDealCampaignChangeStatus)
      .then((response) => {})
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        fetchPrivilegeCampaignList();
      });
  };

  const removeCampaign = (campaignId) => {
    openWarningModal("ลบ Campaign", `ต้องการลบ Campaign นี้ใช่หรือไม่`, () => {
      loading.tableData = true;
      fetchFlashDealCampaignRemove.payload.CampaignId = campaignId;
      store
        .dispatch("api/apiRequest", fetchFlashDealCampaignRemove)
        .then((response) => {
          openSuccessModal();
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          fetchPrivilegeCampaignList();
        });
    });
  };

  onBeforeMount(() => {
    fetchPrivilegeCampaignList();
  });

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchPrivilegeCampaignList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchPrivilegeCampaignList();
    },
    { deep: true }
  );

  return {
    fields,
    loading,
    status,
    statusOption,
    privilegeCampaignList,
    filters,
    ordering,
    pagination,
    onSetValueSearch,
    onSelectFilter,
    onPageChange,
    onFilterEntity,
    resolveDateWithSeperator,
    resolveTime,
    changeCampaignStatus,
    removeCampaign,
    modalPopup,
    onOpenExportModal,
    closeReportModal,
  };
}
